import { useEffect } from "react";
import { getIn } from "formik";

const hasSite = siteId => siteId != null && siteId !== "";

const filterLocationsBySite = (locations = [], siteId) =>
  hasSite(siteId)
    ? locations.filter(location => Number(location?.siteId) === Number(siteId))
    : locations;

const isLocationOutsideSite = ({ locations = [], locationId, siteId }) => {
  if (!hasSite(siteId) || locationId == null || locationId === "") return false;

  const location = locations.find(
    location => Number(location?.id) === Number(locationId),
  );
  return !!location && Number(location.siteId) !== Number(siteId);
};

const toLocationOptions = locations =>
  locations.map(location => ({
    label: location.description,
    value: location.id,
  }));

// Picking a site narrows the location options and clears a location that
// belongs to another site.
const useSiteLocationOptions = ({
  formik,
  locationFieldName,
  locations,
  siteFieldName,
}) => {
  const siteId = getIn(formik?.values, siteFieldName);
  const locationId = getIn(formik?.values, locationFieldName);

  useEffect(() => {
    if (isLocationOutsideSite({ locations, locationId, siteId })) {
      formik.setFieldValue(locationFieldName, null);
    }
  }, [siteId, locationId, locations]);

  return toLocationOptions(filterLocationsBySite(locations, siteId));
};

export { filterLocationsBySite, isLocationOutsideSite, useSiteLocationOptions };
